import type { IApplicationContext } from 'shared/types/applicationContext';

import type { IPostSuperhostRequestParams, TPostSuperhostRequestResponse } from './types';

export async function postSuperhostRequest(
  { httpApi }: IApplicationContext,
  params: IPostSuperhostRequestParams,
): Promise<TPostSuperhostRequestResponse> {
  const { response, statusCode } = await httpApi.fetch(
    {
      apiType: 'external',
      microserviceName: 'info-api',
      assertStatusCodes: [201, 400],
      method: 'POST',
      pathApi: '/api/cian-superhost/v1/request',
      requestContentType: 'json',
      parameters: params,
    },
    {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
      },
    },
  );

  return { statusCode, response } as TPostSuperhostRequestResponse;
}
